import { getVideo, patchLikeVideo, patchUnlikeVideo } from './videoAPI';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// initial State
const initialState = {
    video: {},
    isLoading: false,
    isError: false,
    error: ''
};

// fetch Video
export const fetchVideo = createAsyncThunk('video/fetchVideo', async (id) => {
    const video = await getVideo(id);

    return video;
});

// update Like
export const setLikeVideo = createAsyncThunk('video/likeVideo', async (id) => {
    const video = await patchLikeVideo(id);
    return video;
});

export const setUnlikeVideo = createAsyncThunk('video/unlikeVideo', async (id) => {
    const video = await patchUnlikeVideo(id);
    return video;
});

// create slice
const videoSlice = createSlice({
    name: 'video',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchVideo.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })

            .addCase(fetchVideo.fulfilled, (state, action) => {
                state.isLoading = false;
                state.video = action.payload;
            })

            .addCase(fetchVideo.rejected, (state, action) => {
                state.isLoading = false;
                state.video = {};
                state.isError = true;
                state.error = action.error.message;
            })

            .addCase(setLikeVideo.fulfilled, (state, action) => {
                state.video.likes = action.payload.likes;
            })

            .addCase(setUnlikeVideo.fulfilled, (state, action) => {
                state.video.unlikes = action.payload.unlikes;
            });
    }
});

export default videoSlice.reducer;
